import React from 'react';

const RankingList = ({ rankingList }) => {
    const filteredAndSortedRankingList = [...rankingList]
    .filter(rank => !rank.TLAP_name.includes('SV') && rank.appoint_count > 0)
        .sort((a, b) => b.appoint_count - a.appoint_count)
        .slice(0, 10); 

    return (
        <div className="ranking_list">
                   <h1>ランキング</h1>

            <table className="ranking_table">
                <thead className="ranking_header">
                    <tr>
                        <th>順位</th>
                        <th>グループ</th>
                        <th>名前</th>
                        <th>件数</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredAndSortedRankingList.map((rank, index) => (
                        <tr key={index} className="ranking_row">
                            <td>{index + 1}位</td>
                            <td>{rank.group}</td>
                            <td>{rank.TLAP_name}</td>
                            <td>{rank.appoint_count}件</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default RankingList;
